

export const frontMatter = {
	sidebar_position: 20
};
export const contentTitle = 'Subtraction';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-features-comparison-subtraction-md-3df.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Kinds of images compatible with algorithm",
  "id": "kinds-of-images-compatible-with-algorithm",
  "level": 3
}, {
  "value": "Parameters and default values",
  "id": "parameters-and-default-values",
  "level": 3
}, {
  "value": "Options",
  "id": "options",
  "level": 4
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    admonition: "admonition",
    br: "br",
    code: "code",
    em: "em",
    h1: "h1",
    h3: "h3",
    h4: "h4",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "subtraction",
        children: "Subtraction"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Makes a subtraction between two images."
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "https://image-js.github.io/image-js-typescript/classes/Image.html#subtract",
        title: "github.io link",
        children: ["🖼️ Image options and parameters of ", _jsx(_components.code, {
          children: "subtract"
        }), " method"]
      }), _jsx(_components.br, {}), "\n", _jsxs(_components.a, {
        href: "https://image-js.github.io/image-js-typescript/classes/Mask.html#subtract",
        title: "github.io link",
        children: ["🎭 Mask options and parameters of ", _jsx(_components.code, {
          children: "subtract"
        }), " method"]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Method called ", _jsx(_components.code, {
        children: "subtract"
      }), ", as the name suggests, takes another Image(or Mask) and makes a subtraction between each respective bit.\nIt works like this:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "let mask = new Mask(3, 3, {\n  data: new Uint8Array([1, 1, 1, 1, 1, 1, 1, 1, 1]),\n});\nlet mask2 = new Mask(3, 3, {\n  data: new Uint8Array([1, 1, 1, 0, 0, 0, 0, 0, 1]),\n});\nmask = mask.subtract(mask2);\n// expect mask to equal [0,0,0,1,1,1,1,1,0]\n"
      })
    }), "\n", _jsx(_components.admonition, {
      type: "caution",
      children: _jsx(_components.p, {
        children: "Both masks must have the same size for compatibility reasons. Images must have the same size, channel number and bit depth."
      })
    }), "\n", _jsx(_components.h3, {
      id: "kinds-of-images-compatible-with-algorithm",
      children: "Kinds of images compatible with algorithm"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Image property"
          }), _jsx(_components.th, {
            children: "What it means"
          }), _jsx(_components.th, {
            children: "Possible values"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "bitDepth"
            })
          }), _jsx(_components.td, {
            children: "number of bits per channel"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "[1,8,16]"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "components"
            })
          }), _jsx(_components.td, {
            children: "number of components"
          }), _jsx(_components.td, {
            children: "any"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "alpha"
            })
          }), _jsx(_components.td, {
            children: "is alpha channel allowed"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "false"
            })
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "parameters-and-default-values",
      children: "Parameters and default values"
    }), "\n", _jsx(_components.admonition, {
      type: "info",
      children: _jsx(_components.p, {
        children: "Parameters and options for Images and Masks are the same."
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "other"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "options"
          })
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h4, {
      id: "options",
      children: "Options"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Property"
          }), _jsx(_components.th, {
            children: "Required"
          }), _jsx(_components.th, {
            children: "Default value"
          })]
        })
      }), _jsx(_components.tbody, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://image-js.github.io/image-js-typescript/interfaces/SubtractImageOptions.html#absolute",
              children: _jsx(_components.code, {
                children: "absolute"
              })
            })
          }), _jsx(_components.td, {
            children: "no"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "false"
            })
          })]
        })
      })]
    }), "\n", _jsx(_components.admonition, {
      type: "info",
      children: _jsx(_components.p, {
        children: "The method is also available for Masks."
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

